/* OREN — Welle 2: Lightbox + Material Strip (v3 — HTML callout labels) */
(function(){

  /* ============================================
     LIGHTBOX WITH CALLOUT NOTES
     ============================================ */
  let lightbox = null;
  function ensureLightbox(){
    if(lightbox) return lightbox;
    lightbox = document.createElement('div');
    lightbox.className = 'oren-lightbox';
    lightbox.innerHTML = ''+
      '<div class="oren-lightbox-meta">'+
        '<div class="row" data-meta-code></div>'+
        '<div class="row" data-meta-title></div>'+
      '</div>'+
      '<button class="oren-lightbox-close" aria-label="Close" data-cursor="Close">✕</button>'+
      '<div class="oren-lightbox-inner">'+
        '<div class="oren-lightbox-img-wrap">'+
          '<img class="oren-lightbox-img" alt="" data-lb-img>'+
          '<svg class="oren-lightbox-notes" data-lb-svg></svg>'+
        '</div>'+
      '</div>';
    document.body.appendChild(lightbox);

    lightbox.querySelector('.oren-lightbox-close').addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function(e){
      if(e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') closeLightbox();
    });
    return lightbox;
  }

  function clearNotes(){
    if(!lightbox) return;
    const svg = lightbox.querySelector('[data-lb-svg]');
    if(svg) svg.innerHTML = '';
    const wrap = lightbox.querySelector('.oren-lightbox-img-wrap');
    if(wrap) wrap.querySelectorAll('.note-label').forEach(function(el){ el.remove(); });
  }

  function closeLightbox(){
    if(!lightbox) return;
    lightbox.classList.remove('open');
    document.documentElement.style.overflow = '';
    setTimeout(clearNotes, 400);
  }

  function openLightbox(imgSrc, meta){
    const lb = ensureLightbox();
    const img = lb.querySelector('[data-lb-img]');
    const codeEl = lb.querySelector('[data-meta-code]');
    const titleEl = lb.querySelector('[data-meta-title]');
    const svg = lb.querySelector('[data-lb-svg]');
    const wrap = lb.querySelector('.oren-lightbox-img-wrap');

    img.src = imgSrc;
    codeEl.textContent = meta.code || '';
    titleEl.textContent = meta.title || '';

    img.onload = function(){
      const rect = img.getBoundingClientRect();
      svg.setAttribute('viewBox', '0 0 100 100');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.style.width = rect.width + 'px';
      svg.style.height = rect.height + 'px';
      svg.style.position = 'absolute';
      svg.style.left = '0';
      svg.style.top = '0';
      svg.innerHTML = '';
      wrap.querySelectorAll('.note-label').forEach(function(el){ el.remove(); });

      const notes = meta.notes || defaultNotes();
      notes.forEach(function(n){
        // SVG connector: curved line + anchor dot
        const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        g.setAttribute('class', 'note-group');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        const ax = n.x, ay = n.y, tx = n.tx, ty = n.ty;
        const cx = (ax + tx) / 2 + (n.curve || 8);
        const cy = (ay + ty) / 2;
        path.setAttribute('d', 'M ' + ax + ' ' + ay + ' Q ' + cx + ' ' + cy + ' ' + tx + ' ' + ty);
        path.setAttribute('class', 'note-line');
        path.setAttribute('vector-effect', 'non-scaling-stroke');
        g.appendChild(path);
        const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        dot.setAttribute('cx', ax);
        dot.setAttribute('cy', ay);
        dot.setAttribute('r', '0.6');
        dot.setAttribute('class', 'note-dot');
        g.appendChild(dot);
        svg.appendChild(g);

        // HTML label: navy text on neon marker (readable on any ground)
        const label = document.createElement('div');
        label.className = 'note-label ' + (tx > 60 ? 'right' : 'left');
        label.style.left = tx + '%';
        label.style.top = ty + '%';
        const mark = document.createElement('span');
        mark.className = 'mark';
        mark.textContent = '// ' + n.text;
        label.appendChild(mark);
        wrap.appendChild(label);
      });
    };

    lb.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
  }

  function defaultNotes(){
    return [
      { x: 22, y: 30, tx: 8, ty: 18, text: 'Heavyweight cotton', curve: -10 },
      { x: 70, y: 55, tx: 90, ty: 38, text: 'Cut and sewn by hand', curve: 8 },
      { x: 48, y: 78, tx: 78, ty: 88, text: 'Made to age', curve: 4 }
    ];
  }

  function setupGalleryLightbox(){
    document.addEventListener('click', function(e){
      const item = e.target.closest('.product-gallery-item');
      if(!item) return;
      e.preventDefault();
      const href = item.getAttribute('href');
      const codeBadge = document.querySelector('.product-code-line');
      const titleEl = document.querySelector('.product-title');
      openLightbox(href, {
        code: codeBadge ? codeBadge.textContent.replace(/^\/\/\s*/, '') : '',
        title: titleEl ? titleEl.textContent : ''
      });
    });
  }

  /* ============================================
     STICKY MATERIAL SAMPLE STRIP (v2 — IntersectionObserver)
     No more scroll listeners. No more getBoundingClientRect.
     ============================================ */
  const materialSamples = [
    {
      img: 'https://cdn.shopify.com/s/files/1/1047/9583/2651/files/ChatGPT_Image_10._Mai_2026_19_18_31.png?v=1778435818',
      name: 'Heavyweight cotton',
      spec: '280gsm, mill Sant\u2019Andrea, Tuscany',
      sections: ['materials', 'fragment', 'patina']
    },
    {
      img: 'https://cdn.shopify.com/s/files/1/1047/9583/2651/files/ChatGPTImage10.Juni2026_18_13_50.png?v=1781110034',
      name: 'Brushed wool',
      spec: 'European mills, full hand',
      sections: ['who-wears', 'hand-behind']
    },
    {
      img: 'https://cdn.shopify.com/s/files/1/1047/9583/2651/files/Bildschirmfoto_2025-08-15_um_17.00.26.png?v=1778435842',
      name: 'The studio',
      spec: 'Berlin, one pair of hands',
      sections: ['naming', 'archive-info', 'hand-behind']
    }
  ];

  function setupMaterialStrip(){
    if(!document.body.classList.contains('template-index')) return;
    if(window.matchMedia('(max-width: 900px)').matches) return;

    const strip = document.createElement('div');
    strip.className = 'material-strip';
    strip.innerHTML = ''+
      '<button class="material-strip-close" aria-label="Hide" data-cursor="Hide">✕</button>'+
      '<div class="material-strip-img"><img alt="" data-mat-img></div>'+
      '<div class="material-strip-label">Sample</div>'+
      '<div class="material-strip-name" data-mat-name></div>'+
      '<div class="material-strip-spec" data-mat-spec></div>';
    document.body.appendChild(strip);

    const matImg = strip.querySelector('[data-mat-img]');
    const matName = strip.querySelector('[data-mat-name]');
    const matSpec = strip.querySelector('[data-mat-spec]');

    let userClosed = false;
    strip.querySelector('.material-strip-close').addEventListener('click', function(){
      strip.classList.remove('visible');
      userClosed = true;
    });

    // Build a map: section element -> sample index
    const sectionMap = new Map();
    materialSamples.forEach(function(sample, idx){
      sample.sections.forEach(function(secId){
        const sec = document.getElementById('shopify-section-' + secId) ||
                    document.querySelector('[id*="' + secId + '"]');
        if(sec && !sectionMap.has(sec)) sectionMap.set(sec, idx);
      });
    });
    if(sectionMap.size === 0) return;

    let activeSample = -1;
    const visibleSections = new Set();

    const observer = new IntersectionObserver(function(entries){
      if(userClosed) return;
      entries.forEach(function(en){
        if(en.isIntersecting) visibleSections.add(en.target);
        else visibleSections.delete(en.target);
      });

      // Pick the section closest to viewport mid that's currently visible
      let bestIdx = -1;
      let bestTop = Infinity;
      const viewportMid = window.innerHeight * 0.5;
      visibleSections.forEach(function(sec){
        const rect = sec.getBoundingClientRect();
        const dist = Math.abs(rect.top + rect.height/2 - viewportMid);
        if(dist < bestTop){ bestTop = dist; bestIdx = sectionMap.get(sec); }
      });

      if(bestIdx !== activeSample){
        activeSample = bestIdx;
        if(bestIdx >= 0){
          const s = materialSamples[bestIdx];
          matImg.src = s.img;
          matName.textContent = s.name;
          matSpec.textContent = s.spec;
          strip.classList.add('visible');
        }else{
          strip.classList.remove('visible');
        }
      }
    }, {
      rootMargin: '-20% 0px -20% 0px',
      threshold: 0
    });

    sectionMap.forEach(function(idx, sec){ observer.observe(sec); });
  }

  function init(){
    setupGalleryLightbox();
    setupMaterialStrip();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();
